import React, {useState, useEffect} from 'react';

import {Button, Spinner, Modal, SelectionInput} from 'player-components';


import './style.css';
import { PlusIcon } from '@heroicons/react/20/solid';

const LAST_SELECTED_SETLIST_KEY = 'choirPlayer.lastSelectedSetlistId';

const getLastSelectedSetlistId = () => {
    try {
        return window.localStorage.getItem(LAST_SELECTED_SETLIST_KEY);
    } catch (e) {
        return null;
    }
};

const rememberSelectedSetlistId = (setlistId) => {
    try {
        window.localStorage.setItem(LAST_SELECTED_SETLIST_KEY, String(setlistId));
    } catch (e) {
        // The selection still persists for this mounted player session.
    }
};

const AddToSetlistModal = ({setlists, isOpen, onClose, onSelectNewPlaylist, onConfirm}) => {
    const [selectedSetlistId, setSelectedSetlistId] = useState(
        () => getLastSelectedSetlistId() ?? setlists[0]?.id ?? null
    );
    const selectedSetlist = setlists.find(
        setlist => String(setlist.id) === String(selectedSetlistId)
    ) || null;

    const selectSetlist = (setlist) => {
        const setlistId = setlist?.id ?? null;
        setSelectedSetlistId(setlistId);
        if (setlistId != null) rememberSelectedSetlistId(setlistId);
    };

    const renderSetlists = () => {
        return <div className={'addToSetlistModal-container'}>
            <p>Please select a setlist to add the song to</p>
        <SelectionInput
            items={setlists}
            itemSelected={selectedSetlist}
            onChange={selectSetlist}
        />
        
        </div>
    }

    const renderAddToNew = () => {
        return <div className="addToNew">
            <span>or</span>
            <Button onClick={onSelectNewPlaylist}><PlusIcon />Create new playlist</Button>
        </div>
    }

    useEffect(()=>{
        if (!setlists?.length) {
            return;
        }

        const selectedSetlistStillExists = setlists.some(
            setlist => String(setlist.id) === String(selectedSetlistId)
        );

        if (!selectedSetlistStillExists) {
            const firstSetlistId = setlists[0].id;
            setSelectedSetlistId(firstSetlistId);
            rememberSelectedSetlistId(firstSetlistId);
        }
    },[setlists, selectedSetlistId])

    return <Modal 
        isOpen={isOpen}
        content={<div style={{minHeight: 300}}>
        <p className="mb-4"></p>
        {renderSetlists()}
        {renderAddToNew()}
        </div>}
        closeLabel={'Close'}
        onClose={onClose}
        onConfirm={()=>onConfirm(selectedSetlist)}
        confirmLabel={selectedSetlist ? "Add song to setlist": null}
        confirmable={selectedSetlist}
    />
}

export default AddToSetlistModal;
